var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"inner-navbar"},[_c('a',{staticClass:"brand-link",attrs:{"href":"#/"}},[_vm._v("pulseData")]),_vm._v(" "),_c('div',{staticClass:"nav-items"},[_vm._t("default"),_vm._v(" "),_c('ApplicationMenu'),_vm._v(" "),_c('Avatar')],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8dab552","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/src/components/NavBar.vue
// module id = null
// module chunks = 